import { render } from "./SettingsInput.vue?vue&type=template&id=60cf6c9c"
import script from "./SettingsInput.vue?vue&type=script&lang=js"
export * from "./SettingsInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__